import { atom } from "jotai"

export const errorsDrawerOpenAtom = atom(false)

if (process.env.NODE_ENV !== "production") {
  errorsDrawerOpenAtom.debugLabel = "errorsDrawerOpenAtom"
}
